import enSidebar from './locales/en/sidebar.json';
import enSDK from './locales/en/sdk.json';

export type SidebarTranslation = { translation: typeof enSidebar };
export type SdkTranslation = typeof enSDK;

export const sidebarTranslations: { [lang: string]: SidebarTranslation } = {
  en: {
    translation: enSidebar,
  },
};

const sidebarModules = import.meta.glob('./locales/*/sidebar.json', {
  eager: true,
});

for (const path in sidebarModules) {
  const match = path.match(/\/([a-zA-Z-]+)\/sidebar\.json$/);
  if (match && match[1] && match[1] !== 'en') {
    const langCode = match[1];
    const translationModule = sidebarModules[path];
    const currentTranslationObject =
      (translationModule as any).default || translationModule;
    sidebarTranslations[langCode] = {
      translation: currentTranslationObject,
    };
  }
}

export const sdkTranslations: { [lang: string]: SdkTranslation } = {
  en: enSDK,
};
const sdkModules = import.meta.glob('./locales/*/sdk.json', { eager: true });
for (const path in sdkModules) {
  const match = path.match(/\/([a-zA-Z-]+)\/sdk\.json$/);
  if (match && match[1] && match[1] !== 'en') {
    const langCode = match[1];
    const sdkModule = sdkModules[path];
    const currentSdkObject = (sdkModule as any).default || sdkModule;
    sdkTranslations[langCode] = currentSdkObject;
  }
}
